export default __webpack_public_path__ + "static/media/industrial.3e7f0241.png";